import { Box, Checkbox, Table, TableBody, TableCell, TableHead } from "@material-ui/core";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FC, useEffect, useState } from "react";
import { DA_TABLE_HEADERS_COLUMN } from "../tableData";
import { useDispatch } from "react-redux";
import { EnchancedSortLabel } from "components/tables/tableSortLabel";
import { DaStatusRow } from "./DaStatusRow";
import { daUpdateSettings, selectAllDaIdsList } from "actions/daAndFleetActions";
import { useStyles } from "../styles";
import useResize from "hooks/useResize";
import { DISPATCHER, MANAGER } from "constants/constants";

interface PropsType {
  tableNumber: number;
}

const DaStatusTable: FC<PropsType> = ({ tableNumber }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { width } = useResize();
  const { userData } = useTypeSelectors((state) => state.auth);
  const {
    driverData: { driverList, driverListFilters, idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);
  const [sortId, setSortId] = useState<string>(driverListFilters?.ordering || "badge");

  useEffect(() => {
    setSortId(driverListFilters?.ordering);
  }, [driverListFilters?.ordering]);

  const handleSortChange = (sortId: string | undefined, cellId: string) => {
    if (sortId?.replace("-", "") === cellId) {
      const sortString = `${sortId?.includes("-") ? "" : "-"}${cellId}`;
      setSortId(sortString);
      dispatch(daUpdateSettings({ ordering: sortString }));
    } else {
      setSortId(cellId);
      dispatch(daUpdateSettings({ ordering: cellId }));
    }
  };

  return (
    <Table stickyHeader>
      <TableHead>
        {tableNumber === 1 && (
          <TableCell className={`${classes.tableHeadCell} ${classes.fixedHeight}`}>
            <Box className={classes.tableCellContent}>
              <Checkbox
                onChange={() => dispatch(selectAllDaIdsList())}
                checked={driverList.length === idListForUpdate?.length}
                className={classes.selectCheckbox}
                disabled={[DISPATCHER, MANAGER].includes(userData.role)}
              />
            </Box>
          </TableCell>
        )}
        {DA_TABLE_HEADERS_COLUMN?.filter((col) =>
          width > 840
            ? col.table === tableNumber
            : tableNumber === 1
              ? ["checkbox"].includes(col.id)
              : !["checkbox"].includes(col.id) || ["full_name", "badge"].includes(col.id),
        )
          ?.filter((col: any) => col.id !== "checkbox")
          ?.filter((col: any) =>
            driverListFilters?.activeColumns?.length
              ? width > 840
                ? driverListFilters?.activeColumns?.includes(col.id) || ["full_name", "badge"].includes(col.id)
                : driverListFilters?.activeColumns?.includes(col.id)
              : true,
          )
          ?.map((col: any) => (
            <TableCell key={col.id} className={`${classes.tableHeadCell} ${classes.fixedHeight}`}>
              <Box className={classes.tableCellContent}>
                <EnchancedSortLabel
                  columnId={col.id}
                  columnLabel={col.label}
                  hasSortLabel={col?.hasSort}
                  handleChange={handleSortChange}
                  ordering={sortId}
                />
              </Box>
            </TableCell>
          ))}
      </TableHead>
      <TableBody>
        {driverList.map((row) => (
          <DaStatusRow row={row} tableNumber={tableNumber} />
        ))}
      </TableBody>
    </Table>
  );
};

export default DaStatusTable;
